/* eslint-disable @typescript-eslint/no-empty-function */
export interface UserChannelInfo {
  userId?: string
  pictureUrl?: string
  displayName?: string
}

export abstract class AbstractExtensionChannel {
  constructor() {}

  public abstract init(): void

  public abstract getUserProfile(): Promise<UserChannelInfo>

  public abstract closeWindow(): void
}
